import React from 'react';
import { Button } from './ui/button';

/**
 * Reusable empty state component with icon, title, description, and optional CTA.
 */
export default function EmptyState({ icon: Icon, title, description, actionLabel, onAction, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 text-center animate-in fade-in duration-500 ${className}`}>
      {Icon && (
        <div className="w-14 h-14 rounded-full bg-muted/50 flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-muted-foreground/40" />
        </div>
      )}
      {title && (
        <h3 className="text-sm font-medium text-foreground mb-1">{title}</h3>
      )}
      {description && (
        <p className="text-xs text-muted-foreground max-w-xs">{description}</p>
      )}
      {actionLabel && onAction && (
        <Button variant="link" size="sm" onClick={onAction} className="mt-3 text-xs">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
